<template>
  <div v-if="show" class="cookie-banner">
    <p>
      We use cookies to improve your experience.
    </p>

    <button @click="accept">Accept All</button>
    <button @click="reject">Reject All</button>
  </div>
</template>

<script>
export default {
  name: "CookieBanner",

  data() {
    return {
      show: false
    };
  },

  mounted() {
    const consent = this.getConsent();

    if (!consent) {
      this.show = true;
    } else {
      this.loadServices();
    }
  },

  methods: {
    getConsent() {
      const match = document.cookie
        .split("; ")
        .find(c => c.startsWith("cookie_consent="));

      return match
        ? JSON.parse(decodeURIComponent(match.split("=")[1]))
        : null;
    },

    saveConsent(consent) {
      document.cookie =
        "cookie_consent=" +
        encodeURIComponent(JSON.stringify(consent)) +
        ";max-age=31536000;path=/;SameSite=Lax";
    },

    accept() {
      this.saveConsent({
        necessary: true,
        analytics: true,
        marketing: true
      });

      this.show = false;
      this.loadServices();
    },

    reject() {
      this.saveConsent({
        necessary: true,
        analytics: false,
        marketing: false
      });

      this.show = false;
    },

    loadServices() {
      const consent = this.getConsent();

      if (consent && consent.analytics) {
        this.loadGoogleAnalytics();
      }
    },

    loadGoogleAnalytics() {
      if (document.getElementById("ga-script")) return;

      const script = document.createElement("script");
      script.id = "ga-script";
      script.async = true;
      script.src =
        "https://www.googletagmanager.com/gtag/js?id=G-0T20SLXD9R";

      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];

        window.gtag = function() {
          window.dataLayer.push(arguments);
        };

        window.gtag("js", new Date());
        window.gtag("config", "G-0T20SLXD9R", {
        anonymize_ip: true
        });
      };
    }
  }
};
</script>